import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";

const STEPS = [
  {
    no: "01",
    icon: "ri-building-2-line",
    title: "先查经营主体",
    desc: "看页面是否公示可核验的经营主体与售后地址。只留一个在线客服、找不到责任主体的平台，风险通常更高。",
  },
  {
    no: "02",
    icon: "ri-price-tag-3-line",
    title: "再看价格与收款方式",
    desc: "价格明显低于市场，且只支持扫码转账或个人账户收款的，先停一停。正规渠道的优惠很少需要催促你立刻付款。",
  },
  {
    no: "03",
    icon: "ri-search-line",
    title: "最后搜一次平台名",
    desc: "付款前在站内搜一次平台名称或域名，看看是否已有同类反馈。多花一分钟，可能省下一笔损失。",
  },
];

const CHECKLIST = [
  "主体信息是否清晰可核验",
  "售后与退款规则是否公开",
  "收款账户是否为对公账户",
  "价格是否异常低于市场",
  "是否被催促立即付款",
  "站内是否已有同类反馈",
];

export default function SignalGuide() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="识别要点"
          title="三步判断，一个网站值不值得先付款"
          desc="不需要专业知识，按这个顺序走一遍，大多数明显的问题都能提前发现。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
          {STEPS.map((step) => (
            <div key={step.no} className="relative rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="font-heading text-4xl font-black text-background-300">{step.no}</span>
              <span className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center rounded-md bg-accent-50 text-accent-600">
                <i className={`${step.icon} text-xl`} />
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-6 rounded-lg border border-secondary-200 bg-secondary-50 p-6 md:flex-row md:items-center md:justify-between md:p-7">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-list-check-2 text-xl" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-secondary-950">付款前对照清单</h3>
              <ul className="mt-3 grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
                {CHECKLIST.map((item) => (
                  <li key={item} className="flex items-center gap-2 font-label text-sm text-secondary-900">
                    <i className="ri-checkbox-circle-line text-secondary-600" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <Link
            to="/guides/ponzi-warning-signals"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-600 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700 cursor-pointer"
          >
            阅读完整识别指南
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}